module.exports = __webpack_public_path__ + "img/1204590880.c6257509.jpg";